<template>
  <div class="container">
    <!--Botones de Confirmación y Edición-->
    <div class="d-flex justify-content-end m-2">
      <!--Dropdown de edición-->
      <b-dropdown
        id="dropdown-1"
        size="sm"
        variant="info"
        :class="{ ocultarClass: esHome }"
        text="Editar Elemento"
        class="btn-elemento btn-options"
        v-show="showMenu"
        v-on:click=";(showPosition = false), (showAnimation = false)"
      >
        <b-dropdown-item @click="showSrc = true">Subir video</b-dropdown-item>
        <b-dropdown-item
          @click="
            showAnimation == true
              ? (showAnimation = false)
              : (showAnimation = true)
          "
          >Agregar animación</b-dropdown-item
        >
        <b-dropdown-item
          @click="
            showMargin == true ? (showMargin = false) : (showMargin = true)
          "
          >Agregar margen</b-dropdown-item
        >
        <b-dropdown-item
          @click="
            showPosition == true
              ? (showPosition = false)
              : (showPosition = true)
          "
          >Ajustar posición</b-dropdown-item
        >
        <b-dropdown-item
          @click="showSize == true ? (showSize = false) : (showSize = true)"
          >Ajustar tamaño</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <div v-show="showAnimation" class="options">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar animacion</p>
        </div>
        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div
              @click="addAnimation('fade')"
              class="btn btn-primary py-2 px-2 animation-fade"
            >
              FadeIn
            </div>
            <div style="overflow:hidden ">
              <div
                @click="addAnimation('bounce')"
                class="btn btn-warning py-2 px-2 animation-bounce"
              >
                Bounce
              </div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <div
                @click="addAnimation('lr')"
                class="btn btn-primary py-2 px-2 animation-slide-l-r"
              >
                Slide in
              </div>
            </div>
            <div style="overflow:hidden">
              <div
                @click="addAnimation('rl')"
                class="btn btn-warning py-2 px-2 animation-slide-r-l"
              >
                Slide in
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button
              size="sm"
              v-on:click="showAnimation = false"
              variant="success"
              >Guardar</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <!--NOTE menu margen-->
    <div v-show="showMargin" class="row">
      <div class="col-8 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar Márgenes</p>
        </div>

        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div style="overflow:hidden ">
              <label for="left">Margen izquierdo </label>
              <input
                v-model.number="localMargin['ml']"
                type="number"
                min="0"
                max="8"
                name="left"
                id
              />
            </div>

            <div style="overflow:hidden ">
              <label for="top">Margen superior </label>
              <input
                v-model.number="localMargin['mt']"
                type="number"
                min="0"
                max="8"
                name="top"
                id
              />
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <label for="right">Margen derecho </label>
              <input
                v-model.number="localMargin['mr']"
                type="number"
                min="0"
                max="8"
                name="right"
                id
              />
            </div>
            <div style="overflow:hidden">
              <label for="bottom">Margen inferior </label>
              <input
                v-model.number="localMargin['mb']"
                type="number"
                min="0"
                max="8"
                name="bottom"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div @click="addMargin" class="btn btn-primary m-2">Aplicar</div>

          <div
            @click="
              showMargin == true ? (showMargin = false) : (showMargin = true)
            "
            class="btn btn-danger m-2"
          >
            Cerrar
          </div>
        </div>
      </div>
    </div>

    <div v-show="showPosition" class="pb-2 options col-6">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h3">Posicionar</p>
        </div>
        <div class="p-3">
          <b-button-group
            size="sm"
            class="d-flex flex-row justify-content-center"
          >
            <b-button
              @click="changePosition('left')"
              class="mx-4"
              active
              variant="outline-success"
            >
              <img src="@/assets/f-left.svg" alt />
            </b-button>
            <b-button
              @click="changePosition('center')"
              class="mx-4"
              variant="outline-info"
            >
              <img src="@/assets/f-center.svg" alt />
            </b-button>
            <b-button
              @click="changePosition('right')"
              class="mx-4"
              variant="outline-warning"
            >
              <img src="@/assets/f-right.svg" alt />
            </b-button>
          </b-button-group>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            size="sm"
            v-on:click="showPosition = false"
            variant="success"
            >Guardar</b-button
          >
        </div>
      </div>
    </div>
    <div v-show="showSize" class="pb-2 options">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h3">Tamaño de la imagen</p>
        </div>
        <b-button-toolbar class="m-1">
          <b-button class="mx-1" size="sm" variant="info" v-on:click="size = 30"
            >Chico</b-button
          >
          <b-button class="mx-1" size="sm" variant="info" v-on:click="size = 50"
            >Mediano</b-button
          >
          <b-button class="mx-1" size="sm" variant="info" v-on:click="size = 75"
            >Grande</b-button
          >
          <b-button
            class="mx-1"
            size="sm"
            variant="info"
            v-on:click="size = 100"
            >100%</b-button
          >
        </b-button-toolbar>
        <div class="d-flex justify-content-end">
          <b-button
            size="sm"
            v-on:click=";(showSize = false), saveSize(size)"
            variant="success"
            >Guardar</b-button
          >
        </div>
      </div>
    </div>
    <div v-show="showSrc" class="col-6 p-3 posicionar-container">
      <div>
        <b-form-file
          size="sm"
          accept="video/*"
          browse-text="Abrir"
          placeholder="Selecciona el video"
          :file-name-formatter="setVideo"
        ></b-form-file>
      </div>
      <div class="d-flex justify-content-end">
        <b-button size="sm" v-on:click="showSrc = false" variant="success"
          >Guardar</b-button
        >
      </div>
    </div>

    <div class="d-flex" ref="videocontainer">
      <video
        ref="videoref"
        class="video-element"
        :style="'width: ' + size + '%;'"
        controls
      ></video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'video',
  props: {
    data: Object,
    route: Object,
    idSection: String,
    subid: Number,
    esHome: Boolean,
    online: Boolean,
    elementid: Number
  },
  data() {
    return {
      empty: '',
      showMenu: true,
      showAnimation: false,
      showPosition: false,
      showSrc: false,
      showSize: false,
      showMargin: false,
      nameVideo: '',
      animation: '',
      position: '',
      src: '',
      size: 50,
      localMargin: {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      },
      localPadding: {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
    }
  },
  created() {
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    this.animation = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid]['elements'][this.elementid]['src'][0]['animation']
    this.src = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid]['elements'][this.elementid]['src'][0]['name']

    this.position = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid]['elements'][this.elementid]['position']

    this.size = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid]['elements'][this.elementid]['size']
    this.localMargin = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][this.elementid].margin
    this.localPadding = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][this.elementid].padding
  },
  mounted() {
    this.$refs.videoref.src = this.src
    this.changePosition(this.position)
    this.addAnimation(this.animation)
    this.addMargin()
  },

  methods: {
    addMargin() {
      let textElementMargin = this.$refs.videoref
      textElementMargin.className = ''

      textElementMargin.classList.add('img-element', 'img-fluid')

      textElementMargin.classList.add(
        'pt-' + this.localPadding['pt'],
        'mt-' + this.localMargin['mt']
      )
      textElementMargin.classList.add(
        'pr-' + this.localPadding['pr'],
        'mr-' + this.localMargin['mr']
      )
      textElementMargin.classList.add(
        'pb-' + this.localPadding['pb'],
        'mb-' + this.localMargin['mb']
      )
      textElementMargin.classList.add(
        'pl-' + this.localPadding['pl'],
        'ml-' + this.localMargin['ml']
      )

      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['margin'] = this.localMargin

      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['padding'] = this.localPadding

      window.localStorage.setItem('root', JSON.stringify(this.localRoot))
    },

    setVideo(file) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      // let no_revista = this.localRoot['detalles'][0].num
      this.nameVideo = 'videos/' + file[0].name
      let videoitem = this.$refs.videoref
      videoitem.src = this.nameVideo
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['src'][0][
        'name'
      ] = this.nameVideo
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      //console.log(this.videoitem.src)
    },
    addAnimation(type) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (type) {
        case 'rl':
          /*this.$refs.videoref.classList.remove('animation-slide-l-r')
              this.$refs.videoref.classList.remove('animation-bounce')
              this.$refs.videoref.classList.remove('animation-fade')
              this.$refs.videoref.classList.add('animation-slide-r-l')*/
          this.animation = 'rl'
          break

        case 'lr':
          /*this.$refs.videoref.classList.remove('animation-slide-r-l')
              this.$refs.videoref.classList.remove('animation-bounce')
              this.$refs.videoref.classList.remove('animation-fade')
              this.$refs.videoref.classList.add('animation-slide-l-r')*/
          this.animation = 'lr'
          break
        case 'bounce':
          /*this.$refs.videoref.classList.remove('animation-slide-l-r')
              this.$refs.videoref.classList.remove('animation-slide-r-l')
              this.$refs.videoref.classList.remove('animation-fade')
              this.$refs.videoref.classList.add('animation-bounce')*/
          this.animation = 'bounce'
          break
        case 'fade':
          this.animation = 'fade'
          break

        default:
          break
      }
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['animation'] = this.animation
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    changePosition(position) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (position) {
        case 'left':
          this.$refs.videocontainer.classList.remove('justify-content-end')
          this.$refs.videocontainer.classList.remove('justify-content-center')
          this.$refs.videocontainer.classList.add('justify-content-start')
          this.position = 'left'
          break
        case 'center':
          this.$refs.videocontainer.classList.remove('justify-content-start')
          this.$refs.videocontainer.classList.remove('justify-content-end')
          this.$refs.videocontainer.classList.add('justify-content-center')
          this.position = 'center'
          break
        case 'right':
          this.$refs.videocontainer.classList.remove('justify-content-start')
          this.$refs.videocontainer.classList.remove('justify-content-center')
          this.$refs.videocontainer.classList.add('justify-content-end')
          this.position = 'right'
          break

        default:
          break
      }
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].position = this.position
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    saveSize(size) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['size'] = size
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    }
  }
}
</script>

<style scoped>
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}

.video-element {
  position: relative;
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
}

/*Animación y posición de la imagen*/
.base-animation {
  opacity: 1;
}
.fade-in {
  animation-name: fadeIn;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-delay: 0;
  animation-play-state: running;
}

.animation-fade {
  animation-name: fadeIn;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 0;
  animation-play-state: running;
}
.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-slide-r-l {
  position: relative;
  animation-name: sliderl;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-bounce {
  position: relative;
  animation-name: bounce;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: none;
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}
.posicionar-titulo {
  /* background-color: antiquewhite; */
  border-bottom: solid #b1b0b0 2px;
  border-radius: 8px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}
@keyframes sliderl {
  from {
    left: 3em;
    opacity: 0;
  }
  to {
    left: 0em;
    opacity: 1;
  }
}
@keyframes bounce {
  from {
    bottom: 2.5em;
    opacity: 0;
  }
  to {
    bottom: 0em;
    opacity: 1;
  }
}
</style>
